var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Burger Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Burger Menu_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    d: "M27.8577 8.57031H2.14342C1.35444 8.57031 0.714844 9.20991 0.714844 9.99888C0.714844 10.7879 1.35444 11.4275 2.14342 11.4275H27.8577C28.6467 11.4275 29.2863 10.7879 29.2863 9.99888C29.2863 9.20991 28.6467 8.57031 27.8577 8.57031Z",
    fill: "#CD303B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Base_2",
    d: "M27.8577 18.5703H2.14342C1.35444 18.5703 0.714844 19.2099 0.714844 19.9989C0.714844 20.7879 1.35444 21.4275 2.14342 21.4275H27.8577C28.6467 21.4275 29.2863 20.7879 29.2863 19.9989C29.2863 19.2099 28.6467 18.5703 27.8577 18.5703Z",
    fill: "#CD303B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burgerMenu.ff713aa8b350afa3c9c5c3d7f4438059.svg";
export { ForwardRef as ReactComponent };